import { setAIVoices } from './ai-voices-slices';

import { ApiService } from 'js/src/client';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';

export const fetchAIVoices = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceList();
            dispatch(setAIVoices(response.data));
            return true;
        } catch (error) {
            ErrorReporter.capture(error);
            return false;
        }
    };
};

export const fetchDefaultAIVoice = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await ApiService.aiVoiceV2List({ query: { page_size: 1 } });
            const voices = response.data.results;
            dispatch(setAIVoices(voices));
            const voice = voices[0];
            return voice;
        } catch (error) {
            ErrorReporter.capture(error);
        }
    };
};
